import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Default } from '@rogers/cdk/common/decorators';
const _c0 = ["ds-badge", ""];
const _c1 = [[["ds-icon"]], "*"];
const _c2 = ["ds-icon", "*"];
let BadgeComponent = /*#__PURE__*/(() => {
  class BadgeComponent {}
  BadgeComponent.ɵfac = function BadgeComponent_Factory(t) {
    return new (t || BadgeComponent)();
  };
  BadgeComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BadgeComponent,
    selectors: [["span", "ds-badge", ""]],
    hostVars: 32,
    hostBindings: function BadgeComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("ds-badge", true)("d-inline-flex", true)("align-items-center", true)("mw-100", true)("b-solid", true)("b-1", true)("bradius-16", true)("p-4", true)("ds-bg-feedback-warning", ctx.variant === "warning")("ds-br-feedback-warning", ctx.variant === "warning")("ds-bg-feedback-error", ctx.variant === "error")("ds-br-feedback-error", ctx.variant === "error")("ds-bg-feedback-success", ctx.variant === "success")("ds-br-feedback-success", ctx.variant === "success")("ds-bg-feedback-info", ctx.variant === "info")("ds-br-feedback-info", ctx.variant === "info");
      }
    },
    inputs: {
      variant: "variant"
    },
    standalone: true,
    features: [i0.ɵɵStandaloneFeature],
    attrs: _c0,
    ngContentSelectors: _c2,
    decls: 3,
    vars: 3,
    template: function BadgeComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c1);
        i0.ɵɵprojection(0);
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵprojection(2, 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵclassMapInterpolate1("ds-legal text-bold mb-0 mw-100 px-4 ", "ds-txt-feedback-" + ctx.variant, "");
      }
    },
    encapsulation: 2
  });
  __decorate([Default('warning')], BadgeComponent.prototype, "variant", void 0);
  return BadgeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeComponent };
